import { MINUTE_IN_MS, SECOND_IN_MS } from "@shared/time-constants";

export namespace Constants {
  export const PWA_SHORTCUT_STORAGE_KEY = "pwa-shortcut";
  export const CONCIERGE_DATA_STORAGE_KEY = "pip-data";
  export const CONCIERGE_LOGIN_SHORTCUT_STORAGE_KEY = "concierge-login-action";
  export const INACTIVITY_TIMER_END_TIME_STORAGE_KEY = "inactivity-timer-end-time";
  export const CONCIERGE_INACTIVITY_MONITOR_INTERVAL = MINUTE_IN_MS; // 1 minute
  export const KIOSK_CHECK_IN_INACTIVITY_MONITOR_INTERVAL = 30 * SECOND_IN_MS; // 30 seconds
  export const CONNECTION_MONITOR_INTERVAL = 30 * SECOND_IN_MS; // 30 seconds
}
